module.exports = {
  ACTIVITY_WITH_OVERSPEEDING_ON_PEDAL_PICK_UP: 'activity-with-overspeeding-on-pedal-pick-up',
  ACTIVITY_WITH_OVERSPEEDING_WITHOUT_PEDAL_PICK_UP: 'activity-with-overspeeding-without-pedal-pick-up',
  ACTIVITY_WITHOUT_OVERSPEEDING: 'activity-without-overspeeding',
  FAULT: 'fault',
  FUNCTION_NO_ACTIVATION_POSSIBLE: 'function-no-activation-possible',
  INVALID: 'invalid',
  LIMITATION_ACTIVATED_BY_CRUISE_CONTROL: 'limitation-activated-by-cruise-control',
  RESERVED: 'reserved',
  STAND_BY: 'stand-by',
};
